import {
  Box, Button, Container,
  Flex, Heading, SimpleGrid, SlideFade, Text
} from "@chakra-ui/react"
import { graphql } from "gatsby"
import { injectIntl, IntlShape, Link } from "gatsby-plugin-intl"
import React from "react"
import { Helmet } from "react-helmet"
import { CollectionBox } from "../../components/Cards/Collection"
import Footer from "../../components/Footer"
import { AddOrderNavigationMenu } from "../../components/Form/AddOrderForm"
import { SwiperBlogs } from "../../components/Layout/DestinationBlogs"
import { FAQ } from "../../components/Layout/FAQ"
import { HorizontalPaymentInformation } from "../../components/Layout/HorizontalPaymentInformation"
import { HowtoShopCheaperwithBriddgy } from "../../components/Layout/HowtoShopCheaperwithBriddgy"
import { ShoppingCheapwithBriddgy } from "../../components/Layout/ShoppingCheapwithBriddgy"
import Navbar from "../../components/Navbar"
import { BottomNavbar } from "../../components/Navbar/BottomNavbar"
import { COMMON_MESSAGES, ECOMMERCE_MESSAGES, LANDING_MESSAGES, ORDER_PAGE_MESSAGES, TRAVEL_MESSAGES } from "../../intl/messages"
import { NavigationContext } from "../../providers/navPage"
let setExpandedRef = null
let isStickyRef = null
const AddOrder = ({ data,intl }:{data:any,intl:IntlShape}) => {
  return (
    <NavigationContext.Provider value={{ page: "order" }}>
      <Helmet title={intl.formatMessage(ORDER_PAGE_MESSAGES.title)} defer={false}>
        <meta
          name="description"
          content={intl.formatMessage(ORDER_PAGE_MESSAGES.description)}
        />
      </Helmet>
     
        <Navbar zIndex={11} pos='absolute' color='white' bg='transparent' transition="-ms-transform 150ms,-webkit-transform 150ms,transform 150ms, opacity 50ms 20ms, visibility 0ms 25ms !important;"  _expanded={{_before:{transform:["scaleY(4)","scaleY(4.5)","scaleY(6.25)"],boxShadow:"elevation_4",borderBottomWidth:"1px",bg:"white"}}} _before={{zIndex:0,content:"''",pos:"absolute",top:0,left:0,bottom:0,right:0,bg:"transparent"}} sx={{".tag-shop-cheaper-link":{d:"none"},">div":{maxW:"container.xxxl",".tag-dropdown-nav-menu":{bg:"white"}}}} transition='.3s ease-in-out all'   _highlighted={{_before:{bg:"white"},boxShadow:"elevation_2",pos:"sticky",top:"-1px",bg:"white",color:"text.medium"}}>
          {(expanded,setExpanded,isSticky)=>{isStickyRef=isSticky;setExpandedRef=setExpanded;return(<AddOrderNavigationMenu isSticky={isSticky} setExpanded={setExpanded} expanded={expanded}/>)}}
        </Navbar>
        <BottomNavbar />
      <Box
          px={5}
          overflow='visible'
          className='bg_hekai_blue_wave'
          pt="13rem"
          pb="150px"
          mx='auto'
          color='white'
          pos="relative"
          as="header"
      >
         <Flex mt="55px" alignItems='center' maxW='container.lg' mx='auto'>
              <SlideFade offsetY={"3rem"} in={true}>
                
                  <Heading textAlign='center'  mb={6} fontSize='hb3' fontWeight='bold' as='h1'>
                    {intl.formatMessage(ORDER_PAGE_MESSAGES.onlineshoppingintldeliveredby)}
                    </Heading>
                    <Flex justifyContent='center'>
                      <Text  mb={3} px={[2,3]} py={2} d="inline-block" color='text.dark' borderRadius='base' borderColor='tealBlue.light' as='h2' fontWeight='400' mr={4} bg='white'>
                      {intl.formatMessage(ORDER_PAGE_MESSAGES.deliveredbytrusted)}
                      </Text>
                      <Text mb={3} px={[2,3]} py={2}  d="inline-block" color='text.dark' borderRadius='base' borderColor='tealBlue.light' as='h2' fontWeight='400' bg='white'>
                      {intl.formatMessage(ORDER_PAGE_MESSAGES.intlandflexible)}
                      </Text>
                    </Flex>
                    <Flex mt={8} justifyContent='center'>
                    <Button onClick={()=>{if(isStickyRef){setExpandedRef(true)};document.getElementById("add_order_form_input").focus()}}_hover={{ boxShadow: "elevation_4",transform:"scale(1.05,1.05)" }} transition="-ms-transform 150ms,-webkit-transform 150ms,transform 150ms, opacity 50ms 20ms, visibility 0ms 25ms !important;" className='tag-gotoorderPage' as='span' fontWeight='bold' boxShadow='elevation_5'  mx='auto' cursor='pointer' borderRadius='30px' size='lg' variant='success'>
                      {intl.formatMessage(LANDING_MESSAGES.createorderforfree)}
                    </Button>
                      </Flex>
                </SlideFade>
        </Flex>
      </Box>
      <HorizontalPaymentInformation mb={[20,20,"150px"]}/>
      <ShoppingCheapwithBriddgy/>
      <HowtoShopCheaperwithBriddgy/>
      <Box py="20" bg='outline.light' w="100%" mb={[20, 20, "150px"]} as="section">
        <Container h="100%" maxW="container.xl">
        <Heading mb={4} as='h2' fontSize="hb3" fontWeight="700" textAlign="center">
          {intl.formatMessage(ECOMMERCE_MESSAGES.findinterestingproductsBrStore)}
          </Heading>
          <Text mx='auto' maxW='container.md' mb={10} as='h3' textAlign="center">
          {intl.formatMessage(ECOMMERCE_MESSAGES.orderonlinefrom)}
          </Text>
          <SimpleGrid my={10} columns={[2,3]}  spacing={[1,3,8]} maxW='container.xl' mx='auto'>
        {
          data.collections.nodes.map((item,index)=>(
            <CollectionBox  collection={item}/>
          ))
        }
        </SimpleGrid>
          </Container>
          <Flex justifyContent='center' w='100%' py={5}>
            <Link to={"/shop/"} >
            <Button as='h3' size='lg'  mx='auto' bg='black' color='white'>
              {intl.formatMessage(ECOMMERCE_MESSAGES.moreonlineshopping)}
            </Button>
            </Link>
          </Flex>
      </Box>
     

      <Box w="100%" mb={[20, 20, "150px"]} as="section">
        <Container h="100%" maxW="container.xl">
          <Heading mb={4} as='h2' fontSize="hb3" fontWeight="700" textAlign="center">
          {intl.formatMessage(TRAVEL_MESSAGES.informationfororderers)}
          </Heading>
          <Text mx='auto' maxW='container.md' mb={16} as='h3' textAlign="center">
          {intl.formatMessage(ORDER_PAGE_MESSAGES.followoutshoppinglblog)}
          </Text>
          <SwiperBlogs blogs={data.blogs}/>
        </Container>
      </Box>
      <FAQ/> 
      <Footer />
    </NavigationContext.Provider>
  )
}
export const query = graphql`
  query {
    collections: allShopifyCollection(filter: {productsCount: {gt: 1},title: {nin: ["Computers","Electronics"]}}) {
      nodes {
        descriptionHtml
        image {
          altText
          gatsbyImageData
        }
        title
        slug
      }
    }
    blogs:allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "blog"}, scoppe_tag: {eq: "Orderer"}}}) {
                nodes {
                frontmatter {
                    featuredimage
                    title
                    description
                    tag
                    slug
                }
                }
    }
    visa: file(relativePath: { eq: "visa.png" }) {
      childImageSharp {
        fixed(width: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    mastercard: file(relativePath: { eq: "mastercard.png" }) {
      childImageSharp {
        fixed(width: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    traveler: file(relativePath: { eq: "traveler-deliver.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    ipad: file(relativePath: { eq: "ipad.png" }) {
      childImageSharp {
        fixed(height: 450) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    laptop: file(relativePath: { eq: "laptop.png" }) {
      childImageSharp {
        fixed(height: 450) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
export default injectIntl(AddOrder)
